(function () {
  if (window.__mediaColourFilterInit) return;
  window.__mediaColourFilterInit = true;

  // Reads the currently selected value of the colour option. The picker renders
  // as radio inputs when the option carries swatches, and as a select otherwise.
  function readColour(gallery) {
    var name = gallery.getAttribute('data-colour-option');
    if (!name) return null;

    var radio = document.querySelector(
      'variant-selects input[type="radio"][name="' + name + '"]:checked'
    );
    if (radio) return radio.value;

    var select = document.querySelector('variant-selects select[name="options[' + name + ']"]');
    if (select) return select.value;

    return gallery.getAttribute('data-selected-colour');
  }

  function apply(gallery) {
    var colour = readColour(gallery);
    if (!colour) return;

    var items = gallery.querySelectorAll('[data-media-colour]');
    for (var i = 0; i < items.length; i++) {
      var own = items[i].getAttribute('data-media-colour');
      // Untagged media (lifestyle shots, anything without a colour in its alt)
      // has an empty value and stays visible for every colour.
      items[i].hidden = own !== '' && own !== colour;
    }

    // Sense's slider counts its slides by measuring width, so hidden slides drop
    // out automatically -- but only once it recounts. Without this the "1 / 33"
    // counter and the arrows keep referring to slides that are no longer shown.
    var sliders = gallery.querySelectorAll('slider-component');
    for (var j = 0; j < sliders.length; j++) {
      if (typeof sliders[j].initPages === 'function') sliders[j].initPages();
    }
  }

  function applyAll() {
    var galleries = document.querySelectorAll('media-gallery[data-colour-option]');
    for (var i = 0; i < galleries.length; i++) apply(galleries[i]);
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('variant-selects')) {
      applyAll();
      // Re-apply after the theme has finished swapping the active media.
      setTimeout(applyAll, 150);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }
})();
